import { delay as mswDelay, graphql, HttpResponse } from 'msw';
import { GetLookbookGalleryQuery, GetLookbookGalleryQueryVariables } from './getLookbookGallery';
import type { CurrentLook, ShopProductVariant } from './types';
import { GetLookbookPreviousLooksQuery, GetLookbookPreviousLooksQueryVariables } from './getPreviousLooks';
import { Look, VisionLookResemblanceSubmitInput, VisionOptInUpdateInput, VisionLookStatusUpdateInput } from '../../../types/definitions/vendor/graphql-schema.d';
import { UpdateLookResemblanceAnswerMutation, UpdateLookResemblanceAnswerMutationVariables } from './updateLookResemblanceAnswer';
import { UpdateVisionOptInOutAnswerMutation, UpdateVisionOptInOutAnswerMutationVariables } from './updateVisionOptInOutAnswer';
import { VisionGalleryViewedAtUpdateMutation, VisionGalleryViewedAtUpdateMutationVariables } from './visionGalleryViewedAtUpdate';
import { OnboardingStatus } from '../../../utils/constants/OnboardingStatus';
import { DeleteLookMutation, DeleteLookMutationVariables } from './deleteLook';
const visionId = '1';
const currentLookBookId = '1';
const mockPhotoFullBody = {
  __typename: 'ClientPhoto' as const,
  id: 'mock-full-body-photo-id'
};
const mockReferrals = {
  __typename: 'Referrals' as const,
  incentive: {
    __typename: 'ReferralIncentive' as const,
    recipientCredit: {
      __typename: 'Money' as const,
      value: 2500,
      currency: 'USD' as const
    }
  }
};
const mockProductVariants: ShopProductVariant[] = [{
  __typename: 'ShopProductVariant',
  id: '3763342',
  sku: '3763342',
  url: 'https://www.stitchfix.com/product/Hawker-Rye-Essential-Wash-2-0-Slim-Fit-Pant/7XME4EG2P?sku-id=3582256&color=Navy&size=32&inseam=30&origin=anchoritem&source=anchored-fix&recommended-sku-id=3582256',
  image: {
    baseUrl: 'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/',
    mediaPath: '/v1744936345/qcclxhonr4xdinipyhab.jpg',
    altText: 'Mock Product',
    __typename: 'ShopMedia'
  },
  shopProduct: {
    name: 'Product 1'
  },
  purchased: true,
  inventory: {
    __typename: 'ShopInventory',
    availability: 'AVAILABLE_STOCK'
  }
}, {
  __typename: 'ShopProductVariant',
  id: '3763339',
  sku: '3763339',
  url: 'https://www.stitchfix.com/product/Hawker-Rye-Essential-Wash-2-0-Slim-Fit-Pant/7XME4EG2P?sku-id=3582256&color=Navy&size=32&inseam=30&origin=anchoritem&source=anchored-fix&recommended-sku-id=3582256',
  image: {
    baseUrl: 'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/',
    mediaPath: '/v1744851798/jjusthegehgtp7drnuga.jpg',
    altText: 'Mock Product',
    __typename: 'ShopMedia'
  },
  shopProduct: {
    name: 'Product 2'
  },
  purchased: false,
  inventory: {
    __typename: 'ShopInventory',
    availability: 'AVAILABLE_STOCK'
  }
}, {
  __typename: 'ShopProductVariant',
  id: '3387282',
  sku: '3387282',
  url: 'https://www.stitchfix.com/product/Hawker-Rye-Essential-Wash-2-0-Slim-Fit-Pant/7XME4EG2P?sku-id=3582256&color=Navy&size=32&inseam=30&origin=anchoritem&source=anchored-fix&recommended-sku-id=3582256',
  image: {
    baseUrl: 'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/',
    mediaPath: '/v1650323500/wcer2oe1xcjj8boqmc53.jpg',
    altText: 'Mock Product',
    __typename: 'ShopMedia'
  },
  shopProduct: {
    name: 'Product 3'
  },
  purchased: false,
  inventory: {
    __typename: 'ShopInventory',
    availability: 'OUT_OF_STOCK'
  }
}];
export const allMockLooks: CurrentLook[] = [{
  __typename: 'Look',
  id: 'look1',
  stickerLabel: null,
  resemblesMeAnswer: true,
  image: {
    __typename: 'Image',
    baseUrl: 'https://res.cloudinary.com/stitch-fix-dev/image/upload/',
    mediaPath: '/v1749490826/visual_ai/mock-images/6223ea8d95804a3cfba6bf8304c89c721e6fe7f6_czlkta.png',
    altText: 'Mock Look 1'
  },
  shopProductVariants: mockProductVariants
}, {
  __typename: 'Look',
  id: 'look2',
  stickerLabel: null,
  resemblesMeAnswer: false,
  image: {
    __typename: 'Image',
    baseUrl: 'https://res.cloudinary.com/stitch-fix-dev/image/upload/',
    mediaPath: '/v1749490826/visual_ai/mock-images/73439412cbd8d8afeb6e9aadd02c08e112beb199_pddotx.png',
    altText: 'Mock Look 2'
  },
  shopProductVariants: mockProductVariants.slice(0, 1)
}, {
  __typename: 'Look',
  id: 'look3',
  stickerLabel: null,
  resemblesMeAnswer: true,
  image: {
    __typename: 'Image',
    baseUrl: 'https://res.cloudinary.com/stitch-fix-dev/image/upload/',
    mediaPath: '/v1749490825/visual_ai/mock-images/938b068d6c2caf93722916edae3fa132d5831cc3_uigxvr.png',
    altText: 'Mock Look 3'
  },
  shopProductVariants: mockProductVariants.slice(0, 2)
}, {
  __typename: 'Look',
  id: 'look4',
  stickerLabel: null,
  resemblesMeAnswer: true,
  image: {
    __typename: 'Image',
    baseUrl: 'https://res.cloudinary.com/stitch-fix-dev/image/upload/',
    mediaPath: '/v1749490825/visual_ai/mock-images/eb2b0bb8c363a6a3880cd084a01f4a1a1b0e56ab_khzhjm.png',
    altText: 'Mock Look 4'
  },
  shopProductVariants: mockProductVariants.slice(0, 2)
}, {
  __typename: 'Look',
  id: 'look5',
  stickerLabel: null,
  resemblesMeAnswer: false,
  image: {
    __typename: 'Image',
    baseUrl: 'https://res.cloudinary.com/stitch-fix-dev/image/upload/',
    mediaPath: '/v1749490825/visual_ai/mock-images/885b6eec045bcfe4824b2079dd39309046e90755_mtdamx.png',
    altText: 'Mock Look 5'
  },
  shopProductVariants: mockProductVariants.slice(0, 2)
}, {
  __typename: 'Look',
  id: 'look6',
  stickerLabel: null,
  resemblesMeAnswer: true,
  image: {
    __typename: 'Image',
    baseUrl: 'https://res.cloudinary.com/stitch-fix-dev/image/upload/',
    mediaPath: '/v1749490825/visual_ai/mock-images/6a554c79694961ebf103a8ebb23019435fc7d3bd_t2u6jo.png',
    altText: 'Mock Look 6'
  },
  shopProductVariants: mockProductVariants.slice(0, 2)
}, {
  __typename: 'Look',
  id: 'look7',
  stickerLabel: null,
  resemblesMeAnswer: true,
  image: {
    __typename: 'Image',
    baseUrl: 'https://res.cloudinary.com/stitch-fix-dev/image/upload/',
    mediaPath: '/v1749490825/visual_ai/mock-images/2d99c39f5fb5bc5b63cebe1a3aa6df71b699f314_yqkdqj.png',
    altText: 'Mock Look 7'
  },
  shopProductVariants: mockProductVariants.slice(0, 2)
}, {
  __typename: 'Look',
  id: 'look8',
  stickerLabel: null,
  resemblesMeAnswer: true,
  image: {
    __typename: 'Image',
    baseUrl: 'https://res.cloudinary.com/stitch-fix-dev/image/upload/',
    mediaPath: '/v1749490824/visual_ai/mock-images/2800ca64ad4c3ca1db3bdd39b765c76157e5f2e7_g3srly.png',
    altText: 'Mock Look 8'
  },
  shopProductVariants: mockProductVariants.slice(0, 2)
}];
export const defaultLookbook = {
  __typename: 'Query',
  client: {
    __typename: 'Client',
    businessLine: 'WOMENS' as const,
    photoFullBody: mockPhotoFullBody,
    referrals: mockReferrals,
    vision: {
      __typename: 'Vision',
      id: visionId,
      onboardingStatus: OnboardingStatus.FULLY_ONBOARDED,
      isOptedInToRecurringLooks: true,
      galleryQuickActionModule: null,
      currentLookBook: {
        id: currentLookBookId,
        __typename: 'LookBook',
        looks: allMockLooks.slice(0, 3)
      },
      notification: null
    }
  }
} satisfies GetLookbookGalleryQuery;
export const defaultLookbookMissingFullBody = {
  __typename: 'Query',
  client: {
    __typename: 'Client',
    businessLine: 'WOMENS' as const,
    photoFullBody: null,
    referrals: mockReferrals,
    vision: {
      __typename: 'Vision',
      id: visionId,
      onboardingStatus: OnboardingStatus.FULLY_ONBOARDED,
      isOptedInToRecurringLooks: true,
      galleryQuickActionModule: null,
      currentLookBook: {
        id: currentLookBookId,
        __typename: 'LookBook',
        looks: allMockLooks.slice(0, 3)
      },
      notification: null
    }
  }
} satisfies GetLookbookGalleryQuery;
export const defaultLookbookWithInfoBanner = {
  __typename: 'Query',
  client: {
    __typename: 'Client',
    businessLine: 'WOMENS' as const,
    photoFullBody: mockPhotoFullBody,
    referrals: mockReferrals,
    vision: {
      __typename: 'Vision',
      id: visionId,
      onboardingStatus: OnboardingStatus.FULLY_ONBOARDED,
      isOptedInToRecurringLooks: true,
      galleryQuickActionModule: null,
      notification: {
        __typename: 'VisionNotification',
        productTrackingName: 'vision_banner_notification',
        productTrackingContentId: 'profile_image_upload',
        productTrackingActionName: 'navigate_to_vision_profile_image_upload',
        banner: {
          __typename: 'ModeBannerSlim',
          id: 'banner-1',
          variant: 'CITRUS',
          message: 'Your images are taking a little longer than expected. Please check back later.',
          icon: null,
          cta: null
        }
      },
      currentLookBook: {
        id: currentLookBookId,
        __typename: 'LookBook',
        looks: allMockLooks.slice(0, 3)
      }
    }
  }
} satisfies GetLookbookGalleryQuery;
export const defaultLookbookWithErrorBanner = {
  __typename: 'Query',
  client: {
    __typename: 'Client',
    businessLine: 'WOMENS' as const,
    photoFullBody: mockPhotoFullBody,
    referrals: mockReferrals,
    vision: {
      __typename: 'Vision',
      id: visionId,
      onboardingStatus: OnboardingStatus.ONBOARDING_FAILED,
      isOptedInToRecurringLooks: true,
      galleryQuickActionModule: null,
      notification: {
        __typename: 'VisionNotification',
        productTrackingName: 'vision_banner_notification',
        productTrackingContentId: 'profile_image_upload',
        productTrackingActionName: 'navigate_to_vision_profile_image_upload',
        banner: {
          __typename: 'ModeBannerSlim',
          id: 'banner-err-1',
          variant: 'URGENT',
          message: 'Action required: Upload profile pictures',
          icon: 'ERROR',
          cta: {
            __typename: 'CallToAction',
            url: 'https://www.stitchfix.com/profile/photos',
            label: {
              __typename: 'I18nCopy',
              text: 'View profile photos'
            }
          }
        }
      },
      currentLookBook: {
        id: currentLookBookId,
        __typename: 'LookBook',
        looks: allMockLooks.slice(0, 3)
      }
    }
  }
} satisfies GetLookbookGalleryQuery;
export const onboardedWithNoGalleries = {
  __typename: 'Query',
  client: {
    __typename: 'Client',
    businessLine: 'WOMENS' as const,
    photoFullBody: mockPhotoFullBody,
    referrals: mockReferrals,
    vision: {
      __typename: 'Vision',
      id: visionId,
      onboardingStatus: OnboardingStatus.FULLY_ONBOARDED,
      isOptedInToRecurringLooks: true,
      galleryQuickActionModule: null,
      notification: null
    }
  }
} satisfies GetLookbookGalleryQuery;
export const defaultLookbookOptedOut = {
  __typename: 'Query',
  client: {
    __typename: 'Client',
    businessLine: 'WOMENS' as const,
    photoFullBody: mockPhotoFullBody,
    referrals: mockReferrals,
    vision: {
      __typename: 'Vision',
      id: visionId,
      onboardingStatus: OnboardingStatus.FULLY_ONBOARDED,
      isOptedInToRecurringLooks: false,
      galleryQuickActionModule: null,
      currentLookBook: {
        id: currentLookBookId,
        __typename: 'LookBook',
        looks: allMockLooks.slice(0, 3)
      },
      notification: null
    }
  }
} satisfies GetLookbookGalleryQuery;
export const noLookbook = {
  __typename: 'Query',
  client: {
    __typename: 'Client',
    businessLine: 'WOMENS' as const,
    photoFullBody: mockPhotoFullBody,
    referrals: mockReferrals,
    vision: {
      __typename: 'Vision',
      id: visionId,
      onboardingStatus: OnboardingStatus.PENDING,
      isOptedInToRecurringLooks: true,
      galleryQuickActionModule: null,
      notification: null
    }
  }
} satisfies GetLookbookGalleryQuery;
export const currentGalleryEmptyMissingFullBody = {
  __typename: 'Query',
  client: {
    __typename: 'Client',
    businessLine: 'WOMENS' as const,
    photoFullBody: null,
    referrals: mockReferrals,
    vision: {
      __typename: 'Vision',
      id: visionId,
      onboardingStatus: OnboardingStatus.FULLY_ONBOARDED,
      isOptedInToRecurringLooks: true,
      galleryQuickActionModule: null,
      currentLookBook: {
        id: currentLookBookId,
        __typename: 'LookBook',
        looks: []
      },
      notification: null
    }
  }
} satisfies GetLookbookGalleryQuery;
export const currentGalleryEmpty = {
  __typename: 'Query',
  client: {
    __typename: 'Client',
    businessLine: 'WOMENS' as const,
    photoFullBody: mockPhotoFullBody,
    referrals: mockReferrals,
    vision: {
      __typename: 'Vision',
      id: visionId,
      onboardingStatus: OnboardingStatus.FULLY_ONBOARDED,
      isOptedInToRecurringLooks: true,
      galleryQuickActionModule: null,
      currentLookBook: {
        id: currentLookBookId,
        __typename: 'LookBook',
        looks: [] // Empty array to trigger CurrentGalleryEmpty component
      },
      notification: null
    }
  }
} satisfies GetLookbookGalleryQuery;
export const defaultPreviousLooks = {
  client: {
    vision: {
      __typename: 'Vision',
      id: visionId,
      previousLooks: {
        __typename: 'LookConnection',
        pageInfo: {
          __typename: 'PageInfo',
          hasNextPage: true,
          endCursor: null
        },
        nodes: allMockLooks.slice(3, 8)
      }
    }
  }
} satisfies GetLookbookPreviousLooksQuery;
export const noPreviousLooks = {
  client: {
    vision: {
      __typename: 'Vision',
      id: visionId,
      previousLooks: {
        __typename: 'LookConnection',
        pageInfo: {
          __typename: 'PageInfo',
          hasNextPage: false,
          endCursor: null
        },
        nodes: []
      }
    }
  }
} satisfies GetLookbookPreviousLooksQuery;
const generateLookResemblanceMock = (resemblesMeAnswer: boolean, lookId: string): UpdateLookResemblanceAnswerMutation => ({
  __typename: 'Mutation',
  visionLookResemblanceSubmit: {
    __typename: 'VisionLookResemblanceSubmitPayload',
    result: {
      __typename: 'VisionLookResemblanceSubmitSuccess',
      look: {
        __typename: 'Look',
        id: lookId,
        resemblesMeAnswer
      }
    }
  }
});
const generateErrorMock = (message = 'Failed to update resemblance answer'): UpdateLookResemblanceAnswerMutation => ({
  __typename: 'Mutation',
  visionLookResemblanceSubmit: {
    __typename: 'VisionLookResemblanceSubmitPayload',
    result: {
      __typename: 'VisionLookResemblanceSubmitError',
      message
    }
  }
});
export const mockUpdateLookResemblanceHandler = ({
  delay,
  returnError = false
}: {
  delay: number;
  returnError?: boolean;
}) => graphql.mutation<UpdateLookResemblanceAnswerMutation, UpdateLookResemblanceAnswerMutationVariables>('updateLookResemblanceAnswer', async ({
  variables
}) => {
  const input = variables.input as VisionLookResemblanceSubmitInput;
  const {
    resemblesMeAnswer,
    lookId
  } = input;
  const mockData = returnError ? generateErrorMock() : generateLookResemblanceMock(resemblesMeAnswer, lookId);
  await mswDelay(delay);
  return HttpResponse.json({
    data: mockData
  });
});
const generateVisionOptInOutSuccessMock = (optIn: boolean): UpdateVisionOptInOutAnswerMutation => ({
  __typename: 'Mutation',
  visionOptInUpdate: {
    __typename: 'VisionOptInUpdatePayload',
    result: {
      __typename: 'VisionOptInUpdateSuccess',
      vision: {
        __typename: 'Vision',
        id: visionId,
        isOptedInToRecurringLooks: optIn
      }
    }
  }
});
const generateVisionOptInOutErrorMock = (message = 'Failed to update opt-in status'): UpdateVisionOptInOutAnswerMutation => ({
  __typename: 'Mutation',
  visionOptInUpdate: {
    __typename: 'VisionOptInUpdatePayload',
    result: {
      __typename: 'VisionOptInUpdateError',
      message
    }
  }
});
export const mockUpdateVisionOptInOutHandler = ({
  delay,
  returnError = false
}: {
  delay: number;
  returnError?: boolean;
}) => graphql.mutation<UpdateVisionOptInOutAnswerMutation, UpdateVisionOptInOutAnswerMutationVariables>('updateVisionOptInOutAnswer', async ({
  variables
}) => {
  const input = variables.input as VisionOptInUpdateInput;
  const {
    optIn
  } = input;
  const mockData = returnError ? generateVisionOptInOutErrorMock() : generateVisionOptInOutSuccessMock(optIn);
  await mswDelay(delay);
  return HttpResponse.json({
    data: mockData
  });
});
export const mockVisionGalleryViewedAtUpdateHandler = ({
  delay,
  returnError = false
}: {
  delay: number;
  returnError?: boolean;
}) => graphql.mutation<VisionGalleryViewedAtUpdateMutation, VisionGalleryViewedAtUpdateMutationVariables>('visionGalleryViewedAtUpdate', async ({
  variables
}) => {
  const input = variables.input;
  const mockData: VisionGalleryViewedAtUpdateMutation = returnError ? {
    __typename: 'Mutation',
    visionGalleryViewedAtUpdate: {
      __typename: 'VisionGalleryViewedAtUpdatePayload',
      result: {
        __typename: 'VisionGalleryViewedAtUpdateError',
        message: 'Failed to update vision gallery viewedAt'
      }
    }
  } : {
    __typename: 'Mutation',
    visionGalleryViewedAtUpdate: {
      __typename: 'VisionGalleryViewedAtUpdatePayload',
      result: {
        __typename: 'VisionGalleryViewedAtUpdateSuccess',
        id: input.id
      }
    }
  };
  await mswDelay(delay);
  return HttpResponse.json({
    data: mockData
  });
});
export const mockLookbookHandler = (mockData: GetLookbookGalleryQuery, {
  delay
}: {
  delay?: number | null;
} = {}) => graphql.query<GetLookbookGalleryQuery, GetLookbookGalleryQueryVariables>('getLookbookGallery', async () => {
  if (delay) {
    await mswDelay(delay);
  }
  return HttpResponse.json({
    data: mockData
  });
});
export const mockLookbookLoadingHandler = ({
  delay
}: {
  delay?: number;
}) => graphql.query<GetLookbookGalleryQuery, GetLookbookGalleryQueryVariables>('getLookbookGallery', async () => {
  await mswDelay(delay);
  return HttpResponse.json({});
});
export const mockPreviousLooksHandler = (mockData: GetLookbookPreviousLooksQuery, {
  delay
}: {
  delay?: number | null;
} = {}) => graphql.query<GetLookbookPreviousLooksQuery, GetLookbookPreviousLooksQueryVariables>('getLookbookPreviousLooks', async () => {
  const response = mockData;
  if (delay) {
    await mswDelay(delay);
  }
  return HttpResponse.json({
    data: response
  });
});
export const simplePaginationHandler = graphql.query('getLookbookPreviousLooks', ({
  variables
}) => {
  const {
    page
  } = variables;
  const pageSize = 5;
  const startIndex = (page - 1) * pageSize;
  const endIndex = startIndex + pageSize;
  const pageData = allMockLooks.slice(startIndex, endIndex);
  return HttpResponse.json({
    data: {
      client: {
        __typename: 'Client',
        vision: {
          __typename: 'Vision',
          id: visionId,
          previousLooks: {
            __typename: 'LookConnection',
            nodes: pageData,
            pageInfo: {
              __typename: 'PageInfo',
              hasNextPage: endIndex < allMockLooks.length,
              endCursor: endIndex < allMockLooks.length ? `${page}` : null
            }
          }
        }
      }
    }
  });
});
export const deleteTestPaginationHandler = graphql.query('getLookbookPreviousLooks', ({
  variables
}) => {
  const {
    page
  } = variables;
  const testLooks = allMockLooks.slice(3, 8); // Use looks 4-8 for testing
  const filteredTestLooks = testLooks.filter(look => !deletedLookIds.has(look.id));
  const pageSize = 5;
  const startIndex = (page - 1) * pageSize;
  const endIndex = startIndex + pageSize;
  const pageData = filteredTestLooks.slice(startIndex, endIndex);
  return HttpResponse.json({
    data: {
      client: {
        __typename: 'Client',
        vision: {
          __typename: 'Vision',
          id: visionId,
          previousLooks: {
            __typename: 'LookConnection',
            nodes: pageData,
            pageInfo: {
              __typename: 'PageInfo',
              hasNextPage: false,
              endCursor: null
            }
          }
        }
      }
    }
  });
});
export const paginatePreviousLooksHandler = (pages: Look[][]) => {
  const pageData = new Map<number, Look[]>();
  return graphql.query('getLookbookPreviousLooks', ({
    variables
  }) => {
    const {
      page
    } = variables;
    const currentPage = typeof page === 'number' ? page : 1;
    if (pageData.has(currentPage)) {
      return HttpResponse.json({
        data: {
          client: {
            __typename: 'Client',
            vision: {
              __typename: 'Vision',
              id: visionId,
              previousLooks: {
                __typename: 'LookConnection',
                nodes: pageData.get(currentPage) || [],
                pageInfo: {
                  __typename: 'PageInfo',
                  hasNextPage: currentPage < pages.length,
                  endCursor: currentPage < pages.length ? `${currentPage}` : null
                }
              }
            }
          }
        }
      });
    }
    if (currentPage > pages.length) {
      return HttpResponse.json({
        data: {
          client: {
            __typename: 'Client',
            vision: {
              __typename: 'Vision',
              id: visionId,
              previousLooks: {
                __typename: 'LookConnection',
                nodes: [],
                pageInfo: {
                  __typename: 'PageInfo',
                  hasNextPage: false,
                  endCursor: null
                }
              }
            }
          }
        }
      });
    }
    const looks = pages[currentPage - 1] || [];
    pageData.set(currentPage, looks);
    const hasNextPage = currentPage < pages.length;
    const endCursor = hasNextPage ? `${currentPage}` : null;
    return HttpResponse.json({
      data: {
        client: {
          __typename: 'Client',
          vision: {
            __typename: 'Vision',
            id: visionId,
            previousLooks: {
              __typename: 'LookConnection',
              nodes: looks,
              pageInfo: {
                __typename: 'PageInfo',
                hasNextPage,
                endCursor
              }
            }
          }
        }
      }
    });
  });
};
const deletedLookIds = new Set<string>();
export const mockDeleteLookHandler = ({
  delay,
  returnError = false
}: {
  delay: number;
  returnError?: boolean;
}) => graphql.mutation<DeleteLookMutation, DeleteLookMutationVariables>('deleteLook', async ({
  variables
}) => {
  const input = variables.input as VisionLookStatusUpdateInput;
  const {
    lookId,
    status
  } = input;
  if (status === 'DELETED' && !returnError) {
    deletedLookIds.add(lookId);
  }
  const mockData: DeleteLookMutation = returnError ? {
    __typename: 'Mutation',
    visionLookStatusUpdate: {
      __typename: 'VisionLookStatusUpdatePayload',
      result: {
        __typename: 'VisionLookStatusUpdateError',
        message: 'Failed to delete image'
      }
    }
  } : {
    __typename: 'Mutation',
    visionLookStatusUpdate: {
      __typename: 'VisionLookStatusUpdatePayload',
      result: {
        __typename: 'VisionLookStatusUpdateSuccess',
        lookUpdated: true
      }
    }
  };
  await mswDelay(delay);
  return HttpResponse.json({
    data: mockData
  });
});
export const mockLookbookHandlerWithDelete = (mockData: GetLookbookGalleryQuery, {
  delay
}: {
  delay?: number | null;
} = {}) => graphql.query<GetLookbookGalleryQuery, GetLookbookGalleryQueryVariables>('getLookbookGallery', async () => {
  const filteredData = {
    ...mockData,
    client: mockData.client ? {
      ...mockData.client,
      vision: mockData.client.vision ? {
        ...mockData.client.vision,
        currentLookBook: mockData.client.vision.currentLookBook ? {
          ...mockData.client.vision.currentLookBook,
          looks: mockData.client.vision.currentLookBook.looks.filter(look => !deletedLookIds.has(look.id))
        } : mockData.client.vision.currentLookBook
      } : mockData.client.vision
    } : mockData.client
  };
  if (delay) {
    await mswDelay(delay);
  }
  return HttpResponse.json({
    data: filteredData
  });
});
export const mockPreviousLooksHandlerWithDelete = (mockData: GetLookbookPreviousLooksQuery, {
  delay
}: {
  delay?: number | null;
} = {}) => graphql.query<GetLookbookPreviousLooksQuery, GetLookbookPreviousLooksQueryVariables>('getLookbookPreviousLooks', async () => {
  const originalNodes = mockData.client?.vision?.previousLooks?.nodes || [];
  const filteredNodes = originalNodes.filter(look => !deletedLookIds.has(look.id));
  const filteredData = {
    ...mockData,
    client: mockData.client ? {
      ...mockData.client,
      vision: mockData.client.vision ? {
        ...mockData.client.vision,
        previousLooks: mockData.client.vision.previousLooks ? {
          ...mockData.client.vision.previousLooks,
          nodes: filteredNodes
        } : mockData.client.vision.previousLooks
      } : mockData.client.vision
    } : mockData.client
  };
  if (delay) {
    await mswDelay(delay);
  }
  return HttpResponse.json({
    data: filteredData
  });
});
export const resetDeletedLooks = () => {
  deletedLookIds.clear();
};